import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialAPIAccessState = {
  APIAccessStatus: STATUS.IDLE,
  APIAccessData: [],
};

export default (state = initialAPIAccessState, action) => {
  switch (action?.type) {
    case types.LOAD_API_ACCESS: {
      return {
        ...state,
        APIAccessStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_API_ACCESS): {
      return {
        ...state,
        APIAccessData: action?.payload?.results,
        APIAccessStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_API_ACCESS):
      return {
        ...state,
        error: true,
        APIAccessStatus: STATUS.ERROR,
      };

    /*  case types.UPDATE_API_ACCESS: {
      const APIAccess = action.data;
      const APIAccessUUID = action.uuid;
      const APIAccessPayload = action.payload;

      const index = state.APIAccessData.findIndex(
        (p) => p.uuid === APIAccessUUID,
      );
      console.log('updateindex', index);
      console.log('updateDataUUID', APIAccessUUID);
      console.log('updateDataAPIAccess', APIAccess);
      console.log('updateDataAPIAccessPayload', APIAccessPayload);

      if (index < 0) return state;
      return {
        ...state,
        APIAccessStatus: STATUS.LOADING,
        APIAccessData: [
          ...state.APIAccessData.slice(0, index),
          { ...APIAccessPayload },
          ...state.APIAccessData.slice(index + 1),
        ],
      };
      
    }
    */

    case resolve(types.UPDATE_API_ACCESS): {
      // const integration = action.data;
      //console.log('i', integration);

      const APIAccessUUID = action?.payload?.uuid;
      const APIAccessToUpdate = action?.payload;

      // console.log('updatePayload', action?.payload);
      const index = state?.APIAccessData?.findIndex(
        (p) => p?.uuid === APIAccessUUID,
      );

      if (index < 0) return state;

      return {
        ...state,
        APIAccessData: [
          ...state?.APIAccessData?.slice(0, index),
          { ...APIAccessToUpdate },
          ...state?.APIAccessData?.slice(index + 1),
        ],
        APIAccessStatus: STATUS.LOADED,
      };
    }
    case reject(types.UPDATE_API_ACCESS):
      return {
        ...state,
        error: true,
        APIAccessStatus: STATUS.ERROR,
      };

    case types.CREATE_API_ACCESS: {
      return {
        ...state,
        APIAccessStatus: STATUS.LOADING,
      };
    }
    case resolve(types.CREATE_API_ACCESS): {
      return {
        ...state,
        APIAccessData: [...state?.APIAccessData, action?.payload],
        APIAccessStatus: STATUS.LOADED,
      };
    }
    case reject(types.CREATE_API_ACCESS):
      return {
        ...state,
        error: true,
        APIAccessStatus: STATUS.ERROR,
      };

    case types.DELETE_API_ACCESS: {
      // console.log('action', action);
      // console.log('state.apiaccessdata', state?.APIAccessData);
      const index = state?.APIAccessData?.findIndex(
        (p) => p?.uuid === action?.data,
      );
      // console.log('index', index);
      return {
        ...state,
        APIAccessData: [
          ...state?.APIAccessData?.slice(0, index),
          ...state?.APIAccessData?.slice(index + 1),
        ],
        APIAccessStatus: STATUS.LOADING,
      };
    }
    case resolve(types.DELETE_API_ACCESS): {
      return {
        ...state,
        APIAccessStatus: STATUS.LOADED,
      };
    }
    case reject(types.DELETE_API_ACCESS):
      return {
        ...state,
        error: true,
        APIAccessStatus: STATUS.ERROR,
      };

    default:
      return state;
  }
};
